
import React, { useState, useEffect, useRef } from "react";
// import Header from "../common/components/Header";
import { useNavigate } from "react-router-dom"; // Add this at the top
// import "../Alliteams.css";
import Ordercart from "./Ordercart";

import { Link } from "react-router-dom";

import { FaCommentAlt, FaChevronDown, FaChevronUp } from "react-icons/fa";

import 'semantic-ui-css/semantic.min.css';
import SidescrollAdvertisements from '../Landingpages/Profile/SidescrollAdvertisements';
import axios from 'axios';
import { FaUser, FaShoppingCart, FaCreditCard, FaList, FaHeart, FaMapMarkerAlt, FaBell, FaHeadset, FaCog } from "react-icons/fa";

import { useLocation } from 'react-router-dom';

// import allCartsImage from "./order-delivered.jpg"; // Adjust the path as needed

// import Biryanidata from './Biryanidata';
const Cartsdata = () => {

    const isMobile = window.innerWidth <= 768;
    const navigate = useNavigate(); // Define navigate
    const [filteredItems, setFilteredItems] = useState([]);
    const [cartData, setCartData] = useState([]);

    const [allCategories, setAllCategories] = useState(["Allcarts"]);
    const [activeCategory, setActiveCategory] = useState("Allcarts");
    // Fetch Cart Data
    // Fetch Cart Data
    const [selectedDishId, setSelectedDishId] = useState(null); // Store the selected dishId

    const [selectedCartId, setSelectedCartId] = useState(null);
    const [refresh, setRefresh] = useState(false);  // ✅ Define refresh state
    const handleCategoryClick = (category) => {
        setActiveCategory(category);

        // Ensure React updates the state immediately
        setFilteredItems(prevItems => {
            if (category === "Allcarts") return cartData;
            return cartData.filter(item => item.dishName === category);
        });

        // 🔥 Force Re-Render Immediately
        setTimeout(() => setRefresh(prev => !prev), 0);
    };

    // ✅ Trigger re-fetch when `refresh` changes
    useEffect(() => {
        let selectedItems = activeCategory === "Allcarts"
            ? cartData
            : cartData.filter(item => item.dishName === activeCategory);

        setFilteredItems([...selectedItems]);
    }, [activeCategory, cartData, refresh]); // ✅ Added `refresh` to dependencies

    // ✅ Fetch data function (runs in the background)




    // ✅ Track when `selectedCartId` and `selectedDishId` become available
    useEffect(() => {
        if (!selectedCartId || !selectedDishId) {
            console.warn("⏳ Waiting for selectedCartId and selectedDishId to be set...");
            return;
        }
        console.log("✅ selectedCartId and selectedDishId are now available");
    }, [selectedCartId, selectedDishId]); // ✅ Runs when these values change




    useEffect(() => {
        const userId = localStorage.getItem("userId");
        const token = localStorage.getItem("authToken"); // ✅ get stored token

        if (!userId) {
            console.error("🚨 User ID not found in localStorage!");
            return;
        }

        const fetchCartData = () => {
            axios
                .get(
                    `https://backend.maamaas.com/food/api/cart/${userId}/without-seating`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`, // ✅ include token in headers
                        },
                    }
                )
                .then((response) => {
                    console.log("🛒 Cart Response:", response.data);

                    // ✅ handle if API returns array
                    const cartItems = Array.isArray(response.data)
                        ? response.data[0]?.cartItems || []
                        : response.data.cartItems || [];

                    setCartData(cartItems);

                    const categories = [...new Set(cartItems.map((item) => item.dishName))];
                    setAllCategories(["Allcarts", ...categories]);
                    setFilteredItems(cartItems);
                })
                .catch((error) => console.error("❌ Error fetching cart data:", error));
        };

        // Initial fetch
        fetchCartData();

        // Refresh every 10 seconds
        const interval = setInterval(fetchCartData, 10000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (activeCategory === "Allcarts") {
            setFilteredItems(cartData); // ✅ Show all items
        } else {
            const filtered = cartData.filter(item => item.dishId === activeCategory);
            setFilteredItems(filtered);
        }
    }, [activeCategory, cartData]); // ✅ Depend on activeCategory and cartData



    const dynamicCategories = [...new Set(cartData.map(item => item.dishName))];

    const [bannerData, setBannerData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const vendorId = localStorage.getItem("vendorId");

    useEffect(() => {
        if (!vendorId) return;
        const source = axios.CancelToken.source();

        (async () => {
            try {
                setLoading(true);

                const { data } = await axios.get(
                    `https://backend.maamaas.com/food/api/banner/vendor/${vendorId}`,
                    { cancelToken: source.token }                 // ⬅️ no headers now
                );

                // 🔽 massage the fields once
                setBannerData({
                    ...data,
                    companyName: data.companyName || "No Name",
                });
                setError("");
            } catch (err) {
                if (!axios.isCancel(err)) {
                    console.error(err);
                    setError("Could not load banner details.");
                }
            } finally {
                setLoading(false);
            }
        })();

        return () => source.cancel();
    }, [vendorId]);
    return (
        <>
            <style>
                {`
  /* Hide scrollbar everywhere (Chrome, Safari, Vivaldi, Edge, Opera) */
  .no-scrollbar::-webkit-scrollbar {
      display: none;
  }

  /* Hide scrollbar for Firefox */
  .no-scrollbar {
      scrollbar-width: none;
      -ms-overflow-style: none; 
  }
`}
            </style>

            <div className="container-fluid">
                <div className="row" style={{ marginTop: "50px" }}>
                    <div className="col-lg-2 col-md-3 col-sm-3 col-3">
                        {/* 📌 Desktop View: Category Cards */}
                        <div
                            className="category-sidebar d-none d-sm-block mobile-scrolling-cart no-scrollbar" // Hide on mobile
                            style={{
                                maxHeight: "600px",
                                position: "sticky",
                                top: "0px",
                                marginTop: "5px",
                                height: "100vh",
                                width: "180px",

                                overflow: "auto",

                                /* Hide scrollbar in Chrome / Edge / Safari / Vivaldi */
                                scrollbarWidth: "none",     // Firefox
                                msOverflowStyle: "none",    // IE/Edge

                                /* Chrome/Safari/Vivaldi scrollbar hide */
                                WebkitOverflowScrolling: "touch",
                                WebkitScrollbar: {
                                    display: "none"
                                },

                                /* Vivaldi FIX → push scrollbar outside the view */
                                marginRight: "-20px",
                                paddingRight: "20px"
                            }}
                        >
                            <div className="category-container" style={{
                                overflowY: "auto",
                                height: "556px",
                                marginTop: "68px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                WebkitOverflowScrolling: "touch",
                                WebkitScrollbar: {
                                    display: "none"
                                },
                            }}>
                                {allCategories.map((category, index) => {
                                    const categoryImage =
                                        category === "Allcarts"
                                            ? "allCartsImage"
                                            : cartData.find(item => item.dishName === category)?.dishImage || "";

                                    return (
                                        <div
                                            key={index}
                                            className="category-card"
                                            onClick={() => handleCategoryClick(category)}
                                            style={{
                                                backgroundColor: activeCategory === category ? "rgb(177 93 198)" : "#D9D9D9",
                                                margin: "8px 0",
                                                padding: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                cursor: "pointer",
                                                justifyContent: "center",
                                                borderRadius: "15px",
                                                transition: "0.3s ease-in-out",
                                                boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
                                                height: "165px"
                                            }}>
                                            <img
                                                src={categoryImage}
                                                alt={category}
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    borderRadius: "50%",
                                                    objectFit: "cover",
                                                }}
                                            />
                                            <div className="category-card-body d-flex justify-content-center p-0">
                                                <button
                                                    style={{
                                                        backgroundColor: activeCategory === category ? "#ddd" : "#fff", // Slight color change for active state
                                                        margin: "5px",
                                                        padding: "8px",
                                                        borderRadius: "10px",
                                                        cursor: "pointer",
                                                        transition: "0.3s ease-in-out",
                                                    }}>
                                                    {category}
                                                </button>
                                            </div>

                                        </div>
                                    );
                                })}
                            </div>
                        </div>

                        {/* 📌 Mobile View: Dropdown */}

                    </div>
                    <div className="d-block d-sm-none " style={{ marginTop: "65px", width: "100%" }}>
                        <select
                            className="form-control "
                            onChange={(e) => handleCategoryClick(e.target.value)}
                            value={activeCategory}
                            style={{
                                padding: "8px",
                                borderRadius: "10px",
                                border: "1px solid #ccc",
                                width: "100%",
                                background: "#b15dc6",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "20px"
                            }}
                        >
                            {allCategories.map((category, index) => (
                                <option key={index} value={category}>
                                    {category}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-lg-7 col-md-7 col-sm-12 col-12" >
                        <p className="breadcrumb maamaas-home-bredcums" style={{ marginTop: "40px", fontSize: "18px", marginLeft: "20px", marginBottom: "10px" }}>
                            <Link to="/homepage" style={{ color: "rgb(177, 92, 214)", fontWeight: 'bold', textDecoration: "none" }}>Home</Link>
                            <span className="separator"> &gt; </span><span className="separator"> &gt; </span>
                            <Link
                                to="/Newmenuiteam"
                                style={{ color: "rgb(177, 92, 214)", fontWeight: "bold", textDecoration: "none" }}
                            >
                                {(bannerData?.companyName || "MAAMAAS")
                                    .charAt(0).toUpperCase() + (bannerData?.companyName || "MAAMAAS").slice(1).toLowerCase()}
                            </Link>

                            <span className="separator"> &gt; </span><span className="separator"> &gt; </span>
                            <Link to="" style={{ color: "rgb(177, 92, 214)", fontWeight: 'bold', textDecoration: "none" }}>Cart</Link>
                        </p>

                        <div className="cartsizes hide-scrollbar"
                            style={{
                                marginTop: "28px",
                                padding: "20px",
                                borderRadius: "8px",
                            }}>
                            {/* ✅ Show Ordercart Component When a Category is Clicked */}
                            {/* {filteredItems.length > 0 && ( */}
                            <Ordercart key={activeCategory} filteredDataProp={filteredItems} />

                        </div>
                        <div
                            className="col-lg-3 right-offerss hide-scrollbar"
                            style={{ display: isMobile ? "none" : "block" }}
                        >
                            <SidescrollAdvertisements />
                        </div>
                    </div>
                </div>
            </div>
            <style>
                {`
  /* Hide scrollbar for Chrome, Safari, and Edge */
  .category-sidebar::-webkit-scrollbar,
  .category-container::-webkit-scrollbar {
      width: 6px; /* thin scrollbar */
  }

  .category-sidebar::-webkit-scrollbar-thumb,
  .category-container::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2); /* light gray thumb */
      border-radius: 10px;
  }

  .category-sidebar::-webkit-scrollbar-track,
  .category-container::-webkit-scrollbar-track {
      background: transparent;
  }

  /* For Firefox */
  .category-sidebar,
  .category-container {
      scrollbar-width: thin;
      scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  }
`}
            </style>


        </>
    );
};

export default Cartsdata;

